import { Directive } from '@angular/core';

export enum StatisticPercentage {
  LOW_LEVEL = 'lowLevel',
  MEDIUM_LEVEL = 'mediumLevel',
  HIGH_LEVEL = 'highLevel'
}

@Directive()
export abstract class AbstractUsageStatistics {
  protected getPercentageLevel(percentage: number): StatisticPercentage {
    if (percentage >= 0 && percentage < 60) {
      return StatisticPercentage.LOW_LEVEL;
    }
    if (percentage >= 60 && percentage < 80) {
      return StatisticPercentage.MEDIUM_LEVEL;
    }

    return StatisticPercentage.HIGH_LEVEL;
  }

  protected getTextColorByPercentage(percentage: number): string {
    const level: StatisticPercentage = this.getPercentageLevel(percentage);
    switch (level) {
      case StatisticPercentage.LOW_LEVEL:
        return 'text-proffeo-success';
      case StatisticPercentage.MEDIUM_LEVEL:
        return 'text-proffeo-warning';
      default:
        return 'text-proffeo-danger';
    }
  }

  protected getBackgroundColorByPercentage(percentage: number): string {
    const level: StatisticPercentage = this.getPercentageLevel(percentage);
    switch (level) {
      case StatisticPercentage.LOW_LEVEL:
        return 'bg-proffeo-feedback-success-solid';
      case StatisticPercentage.MEDIUM_LEVEL:
        return 'bg-proffeo-feedback-warning-solid';
      default:
        return 'bg-proffeo-feedback-danger-solid';
    }
  }
}
